<template>
 <div class="app-toast"
    v-if="isShow"
    :class="{'info': type=== 'info','success': type=== 'success','wraning': type=== 'wraning','danger': type=== 'danger','err':type=== 'error'}">{{text}}</div>
</template>
<script>
export default {
  
}
</script>

<style scoped>
.app-toast {
 position: fixed;
 left: 50%;
 top: 130px;
 background: #ccc;
 padding: 10px 20px;
 border-radius: 5px;
 transform: translate(-50%, -50%);
 color: #fff;
 z-index: 999;
}
.info {
 background: #00aaee;
}
.success {
 background: #00ee6b;
}
.wraning {
 background:#323232;
}
.danger {
 background: #323232;
}
.err {
 background: #F56C6C;
}
</style>